import { render } from "./BaseMetricsBox.vue?vue&type=template&id=46127388&scoped=true"
const script = {}

import "./BaseMetricsBox.vue?vue&type=style&index=0&id=46127388&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46127388"]])

export default __exports__